import {NgModule} from '@angular/core';
import {UnsavedChangesNotifierService} from '@application/helper/unsaved-changes-notifier/unsaved-changes-notifier.service';
import {CREELS} from '@infrastructure/http/creel/creels';
import {HttpCreelsService} from '@infrastructure/http/creel/http-creels.service';
import {FINISHINGS} from '@infrastructure/http/finishing/finishings';
import {HttpFinishingsService} from '@infrastructure/http/finishing/http-finishings.service';
import {HttpMachineOverviewService} from '@infrastructure/http/machine-overview/http-machine-overview.service';
import {MACHINE_OVERVIEW} from '@infrastructure/http/machine-overview/machine-overview';
import {HttpPlasticProductionOrdersService} from '@infrastructure/http/plastic-production-order/http-plastic-production-orders.service';
import {HttpProductionOrdersWeavingService} from '@infrastructure/http/production-order-weaving/http-production-orders-weaving.service';
import {PRODUCTION_ORDERS_WEAVING} from '@infrastructure/http/production-order-weaving/production-orders-weaving';
import {HttpProductionOrdersService} from '@infrastructure/http/production-order/http-production-orders.service';
import {PRODUCTION_ORDERS} from '@infrastructure/http/production-order/production-orders';
import {HttpProductionSchedulesService} from '@infrastructure/http/production-schedule/http-production-schedules.service';
import {PRODUCTION_SCHEDULES} from '@infrastructure/http/production-schedule/production-schedules';
import {SignalRPlanningPrototypeService} from '@infrastructure/signalr/planning-prototype/signalr-planning-prototype.service';
import {REALTIME_PRODUCTION_ORDER_LITE} from '@infrastructure/signalr/production-order-lite/realtime-production-order-lite';
import {SignalrProductionOrderLiteService} from '@infrastructure/signalr/production-order-lite/signalr-production-order-lite.service';
import {REALTIME_PRODUCTION_ORDER} from '@infrastructure/signalr/production-order/realtime-production-order';
import {SignalrProductionOrderService} from '@infrastructure/signalr/production-order/signalr-production-order.service';
import {PlasticProductOverviewService} from '@presentation/pages/textile-data/plastic-product/overview/plastic-product-overview.service';
import {ToolOverviewService} from '@presentation/pages/utilities/tool/overview/tool-overview.service';
import {SharedModule} from '@shared/shared.module';
import {DatePickerModule, HeaderModule, PlanningDisplayModule, PlanningDragDropModule, TabsMenuCardModule} from '@vdw/angular-component-library';
import {AgGridModule} from 'ag-grid-angular';
import {CustomerOverviewService} from '../customer/overview/customer-overview.service';
import {MachineGroupFilterComponent} from './machine-group-filter/machine-group-filter.component';
import {FixedSchedulePlaceholderComponent} from './planning-items/fixed-schedule-placeholder/fixed-schedule-placeholder.component';
import {MaintenanceComponent} from './planning-items/maintenance/maintenance.component';
import {PlanningOrderComponent} from './planning-items/planning-order/planning-order.component';
import {PlanningPrototypeComponent} from './planning-prototype.component';
import {planningPrototypeRouting} from './planning-prototype.routing';
import {FixedSchedulePlaceholderSidebarComponent} from './sidebars/fixed-schedule-placeholder-sidebar/fixed-schedule-placeholder-sidebar.component';
import {FixedSchedulesSidebarComponent} from './sidebars/fixed-schedules-sidebar/fixed-schedules-sidebar.component';
import {MachineDetailSidebarComponent} from './sidebars/machine-detail-sidebar/machine-detail-sidebar.component';
import {MaintenanceSidebarComponent} from './sidebars/maintenance-sidebar/maintenance-sidebar.component';
import {PlanningItemDateSelectComponent} from './sidebars/planning-item-date-select/planning-item-date-select.component';
import {PlanningItemSidebarComponent} from './sidebars/planning-item-sidebar/planning-item-sidebar.component';
import {PlanningOrderSidebarComponent} from './sidebars/planning-order-sidebar/planning-order-sidebar.component';
import {PlanningPrototypeSidebarComponent} from './sidebars/planning-prototype-sidebar.component';
import {CreelMappingDisplayComponent} from './sidebars/planning-run-sidebar/creel-mapping/creel-mapping-display/creel-mapping-display.component';
import {CreelMappingEditComponent} from './sidebars/planning-run-sidebar/creel-mapping/creel-mapping-edit/creel-mapping-edit.component';
import {PlanningRunSidebarComponent} from './sidebars/planning-run-sidebar/planning-run-sidebar.component';
import {ProductionOrdersListComponent} from './sidebars/planning-run-sidebar/production-orders-list/production-orders-list.component';
import {SelectFixedScheduleComponent} from './sidebars/planning-run-sidebar/select-fixed-schedule/select-fixed-schedule.component';
import {SelectUnplannedOrderComponent} from './sidebars/planning-run-sidebar/select-unplanned-order/select-unplanned-order.component';
import {ToPlanComponent} from './sidebars/to-plan/to-plan.component';
import {PlanningOrderTooltipComponent} from './tooltips/planning-order-tooltip.component';
import {PlanningFilterService} from './utilities/planning-filter.service';
import {PlanningItemDragDropService} from './utilities/planning-item-drag-drop.service';
import {PlanningPrototypeContextService} from './utilities/planning-prototype-context.service';
import {ProductionOrderUtilities} from './utilities/production-order-utilities.service';

@NgModule({
  declarations: [
    CreelMappingDisplayComponent,
    CreelMappingEditComponent,
    MachineDetailSidebarComponent,
    MachineGroupFilterComponent,
    MaintenanceComponent,
    MaintenanceSidebarComponent,
    PlanningItemDateSelectComponent,
    PlanningItemSidebarComponent,
    PlanningOrderComponent,
    PlanningOrderSidebarComponent,
    PlanningPrototypeComponent,
    PlanningPrototypeSidebarComponent,
    PlanningRunSidebarComponent,
    ProductionOrdersListComponent,
    SelectUnplannedOrderComponent,
    FixedSchedulesSidebarComponent,
    FixedSchedulePlaceholderComponent,
    FixedSchedulePlaceholderSidebarComponent,
    SelectFixedScheduleComponent,
    ToPlanComponent,
    PlanningOrderTooltipComponent
  ],
  imports: [TabsMenuCardModule, HeaderModule, SharedModule, DatePickerModule, PlanningDisplayModule, planningPrototypeRouting, PlanningDragDropModule, AgGridModule],
  providers: [
    PlanningFilterService,
    PlanningItemDragDropService,
    PlanningPrototypeContextService,
    PlasticProductOverviewService,
    ProductionOrderUtilities,
    SignalRPlanningPrototypeService,
    ToolOverviewService,
    CustomerOverviewService,
    PlanningFilterService,
    HttpPlasticProductionOrdersService,
    UnsavedChangesNotifierService,
    {provide: CREELS, useClass: HttpCreelsService},
    {provide: FINISHINGS, useClass: HttpFinishingsService},
    {provide: MACHINE_OVERVIEW, useClass: HttpMachineOverviewService},
    {provide: PRODUCTION_ORDERS, useClass: HttpProductionOrdersService},
    {provide: PRODUCTION_ORDERS_WEAVING, useClass: HttpProductionOrdersWeavingService},
    {provide: PRODUCTION_SCHEDULES, useClass: HttpProductionSchedulesService},
    {provide: REALTIME_PRODUCTION_ORDER, useClass: SignalrProductionOrderService},
    {provide: REALTIME_PRODUCTION_ORDER_LITE, useClass: SignalrProductionOrderLiteService}
  ]
})
export class PlanningPrototypeModule {}
